/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './network-settings.scss';

/* eslint-disable import/no-unresolved, import/default */

import networkSettingsFieldsetTemplate from './network-settings-fieldset.tpl.html';
import editSessionParameterTemplate from './session-dialog/session.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function NetworkSettingsDirective($compile, $templateCache, types, $mdDialog, $document) {
    var linker = function (scope, element) {
        var template = $templateCache.get(networkSettingsFieldsetTemplate);
        element.html(template);

        scope.types = types;
        scope.openEditDialog = openEditDialog;
        scope.convertFrequency = convertFrequency;

        scope.$watch('networkSettings', () => {
           if (scope.networkSettings) {
               scope.originNetworkSettings = angular.copy(scope.networkSettings);
               scope.originSessionNetworkSettings = angular.copy(scope.sessionNetworkSettings);

               if (scope.networkSettings.cfList == null) {
                   scope.networkSettings.cfList = [];
               }
               if (scope.networkSettings.adrNbTransRanges == null) {
                   scope.networkSettings.adrNbTransRanges = {};
               }
               if (!scope.networkSettings.chMaskCtrlDataList || !scope.networkSettings.chMaskCtrlDataList.length) {
                   scope.chMaskOption = types.chMaskOptions.notDefined.value;
               } else {
                   if (angular.equals(scope.networkSettings.chMaskCtrlDataList, types.channelMaskOptionsData.channels8)) {
                       scope.chMaskOption = types.chMaskOptions.channels8.value;
                   } else if (angular.equals(scope.networkSettings.chMaskCtrlDataList, types.channelMaskOptionsData.channels64)) {
                       scope.chMaskOption = types.chMaskOptions.channels64.value;
                   } else {
                       scope.chMaskOption = types.chMaskOptions.custom.value;
                       scope.networkSettings.chMaskCtrlDataList.sort((chMask1, chMask2) => chMask1.chMaskCntl > chMask2.chMaskCntl ? -1 : 1);
                   }
               }
               scope.txParamSetupReqConfigEnabled = (scope.networkSettings.downlinkDwellTime !== null && scope.networkSettings.downlinkDwellTime !== 'null')
                   || (scope.networkSettings.uplinkDwellTime !== null && scope.networkSettings.uplinkDwellTime !== 'null')
                   || (scope.networkSettings.maxEIRP !== null && scope.networkSettings.maxEIRP !== 'null');
           }
        });

        scope.onOffTxParamSetupReqConfig = function() {
            if (!scope.txParamSetupReqConfigEnabled) {
                scope.networkSettings.maxEIRP = null;
                scope.networkSettings.downlinkDwellTime = null;
                scope.networkSettings.uplinkDwellTime = null;
            }
        }

        scope.validateCf = function($chip) {
            if (!$chip) return;
            var freq = Number($chip);
            freq = Math.floor(freq * 10000) / 10000;
            if (freq < 100 || freq > 1670) {
                return null;
            }
            // Fix in order to trigger form event on chip modifications
            scope.theForm.$setDirty();
            return freq;
        };

        scope.chMaskOptionChanged = function() {
            if (scope.chMaskOption != types.chMaskOptions.custom.value) {
                scope.networkSettings.chMaskCtrlDataList = angular.copy(types.channelMaskOptionsData[scope.chMaskOption]);
                scope.theForm.$setDirty();
            }
        };

        scope.removeChMask = function(index) {
            if (index > -1) {
                scope.networkSettings.chMaskCtrlDataList.splice(index, 1);
                scope.theForm.$setDirty();
            }
        }

        scope.addChMask = function () {
            if (!scope.networkSettings.chMaskCtrlDataList) {
                scope.networkSettings.chMaskCtrlDataList = [];
            }
            scope.networkSettings.chMaskCtrlDataList.push(
                {
                    chMask: '',
                    chMaskCntl: ''
                }
            );
            scope.theForm.$setDirty();
        }

        scope.showClassBSettings = function () {
            if (scope.deviceClass) {
                return (scope.deviceClass === types.deviceClass.CLASS_B.value);
            } else {
                // Display class B settings for an application's Advanced Network Settings.
                return true;
            }
        };

        function convertFrequency(input) {
            return input / 1000000;
        }

        function openEditDialog($event, key, title) {
            const onEntitySaved = (newValue) => {
                scope.sessionNetworkSettings[key] = newValue;
            };
            if (title) {
                var onShowingCallback = {
                    onShowing: function () {
                    }
                };
                $mdDialog.show({
                    controller: 'SessionDialogController',
                    controllerAs: 'vm',
                    templateUrl: editSessionParameterTemplate,
                    locals: {
                        title: title,
                        key: key,
                        onSaved: onEntitySaved,
                        showingCallback: onShowingCallback
                    },
                    parent: angular.element($document[0].body),
                    targetEvent: $event,
                    fullscreen: true,
                    skipHide: true,
                    onShowing: function (scope, event) {
                        onShowingCallback.onShowing(scope, event);
                    }
                });
            }
        }

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            networkSettings: '=',
            sessionNetworkSettings: '=?',
            isEdit: '=',
            theForm: '=',
            deviceClass: '=',
            isAbp: '=?'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/network-settings/network-settings.directive.js